"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapTurbosquidApiProcessData = exports.csrfTokenData = exports.mapProcess = exports.mapCredentials = exports.TURBOSQUID_API_ADAPTER = void 0;
exports.TURBOSQUID_API_ADAPTER = 'turbosquid-api-adapter';
var mapCredentials = function (creds) { return ({
    accessKeyId: creds.access_key,
    secretAccessKey: creds.secret_key,
    sessionToken: creds.session_token,
    expireTime: new Date(creds.expiration),
    keyPrefix: creds.key_prefix,
    bucket: creds.bucket,
    region: creds.region,
    currentServerTime: creds.current_server_time,
}); };
exports.mapCredentials = mapCredentials;
var mapProcess = function (process) { return ({
    type: 'process',
    id: process.id,
    attributes: {
        fileId: process.file_id,
        status: process.status,
        imageWidth: process.image_width,
        imageHeight: process.image_height,
        validSearchBackground: process.search_background,
    },
}); };
exports.mapProcess = mapProcess;
var csrfTokenData = function (token) { return ({
    authenticity_token: token,
}); };
exports.csrfTokenData = csrfTokenData;
var mapFileAttributes = function (attributes) { return ({
    draft_id: attributes.draftId,
    name: attributes.name,
    filename: attributes.filename,
    size: attributes.size,
    file_format: attributes.fileFormat,
    thumbnail_type: attributes.thumbnailType,
    watermarked: attributes.watermarked,
    format_version: attributes.formatVersion,
    renderer: attributes.renderer,
    renderer_version: attributes.rendererVersion,
    is_native: attributes.isNative,
    turntable_id: attributes.turntableId,
}); };
var mapTurbosquidApiProcessData = function (key, fileAttributes, token) {
    var resource = fileAttributes.resource, attributes = __rest(fileAttributes, ["resource"]);
    return __assign({ upload_key: key, resource: resource, attributes: mapFileAttributes(attributes) }, exports.csrfTokenData(token));
};
exports.mapTurbosquidApiProcessData = mapTurbosquidApiProcessData;
//# sourceMappingURL=TurbosquidArtistAdaptor.js.map
